export default "__VITE_ASSET__BIsaLI6F__"